import CopyBox from './CopyBox';

export default CopyBox;
